import React, { useState, useEffect, useContext } from "react";

import { ThemeContext } from "styled-components";

/* import services */
import api from "./../../services/api";

/* import utils */
import { filterString } from "./../../util/functions";

import Legend from "./../../components/Legend";
import Search from "./../../components/Search";

/* import icons */
import AddPageIcon from "./../../assets/icons/addPage";

/* import styles */
import { Container, Cards, Card, Title, Subtitle, Comment } from "./styles";

export default function Contact({ toggleTitles }) {
  toggleTitles("Páginas", "Gestão de páginas estática");

  const { status: colors } = useContext(ThemeContext);

  const [searchValue, setSearchValue] = useState("");
  const [searchStatus, setSearchStatus] = useState("");

  const [paginate, setPaginate] = useState({});
  const [data, setData] = useState([]);
  const [initialData, setInitialData] = useState([]);

  const handleFilter = async text => {
    const filtered = initialData.filter(
      item =>
        filterString(item.is_active ?? false, (searchStatus === "inative" ? false : true) ?? "") &&
        (filterString(item.id, text) || filterString(item.title, text) || filterString(item.description ?? "", text) || filterString(item.uri ?? "", text)),
    );
    setData(filtered);
  };

  async function loadData() {
    try {
      const { data } = await api.get(`/pages/`, {});
      await setInitialData(data.data);
      await setData(data.data);
      setPaginate({ lastPage: 0, page: 0, perPage: 0, total: "0" });
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleFilter(searchValue);
  }, [searchStatus]);

  useEffect(() => {
    loadData();
    document.querySelector("#input").focus();
  }, []);

  return (
    <>
      <Container>
        <Legend
          active={searchStatus}
          onClick={status => {
            setSearchStatus(status);
          }}
          items={[
            {
              key: "status",
              value: "active",
              title: "Filtrar Ativos",
              color: colors["active"],
            },
            {
              key: "status",
              value: "inative",
              title: "Filtrar Inativos",
              color: colors["inative"],
            },
          ]}
        />
        <Cards>
          {data.map(({ id, title, description, uri, is_active }) => (
            <Card key={id} to={`pagina/editar/${id}`} status={colors[is_active ? "active" : "inative"]}>
              <Title>{title}</Title>
              <Subtitle>
                {description}
                <br />
                <br />
                <br />
              </Subtitle>
              <Comment>/paginas/{uri}</Comment>
            </Card>
          ))}
        </Cards>

        <Search
          InitialValue={searchValue}
          onChange={text => {
            setSearchValue(text);
            handleFilter(text);
          }}
          btnAdd
          btnAddTo="/pagina/nova"
          btnAddIcon={<AddPageIcon />}
          btnAddtitle="Nova Página"
        />
      </Container>
    </>
  );
}
